console.log("npm install react-three-fiber is deprecated, use @react-three/fiber instead!")